module.exports = __webpack_public_path__ + "static/female_cofounders_logo_green-d23e9881627b772cbcabdcb85b28e689.svg";